import { render } from "./TestTitle.vue?vue&type=template&id=7fe18f1c&scoped=true"
import script from "./TestTitle.vue?vue&type=script&lang=js"
export * from "./TestTitle.vue?vue&type=script&lang=js"

import "./TestTitle.vue?vue&type=style&index=0&id=7fe18f1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe18f1c"]])

export default __exports__